import React from 'react';

export const ShopNewsletterForm = () => (
  <form className="newsletter newsletter--shop" action='https://akkurat.us11.list-manage.com/subscribe/post?u=ea280dd742ccfe0405dbfb8a8&amp;id=d069566616' method='post' id='mc-embedded-subscribe-form' name='mc-embedded-subscribe-form' target='_blank'>
    <input required type='email' name='EMAIL' className='required email' id='mce-EMAIL' placeholder='Join Our Newsletter' />

    <div style={{ 'position': 'absolute', 'left': '-5000px' }}>
      <input type='text' name='b_ea280dd742ccfe0405dbfb8a8_d069566616' tabIndex='-1' />
    </div>

    <button type='submit' id='mc-embedded-subscribe'>
      Send
    </button>
  </form>
)


export const InformationNewsletterForm = () => (
  <form className="newsletter newsletter--information" action='https://akkurat.us11.list-manage.com/subscribe/post?u=ea280dd742ccfe0405dbfb8a8&amp;id=d069566616' method='post' id='mc-embedded-subscribe-form' name='mc-embedded-subscribe-form' target='_blank'>
    <input required type='email' name='EMAIL' className='required email' id='mce-EMAIL' placeholder='Enter Your E-Mail' />

    <div className="lower">
      <div className="description">Subscribe to our weekly dose, a list of what we’re enjoying or pondering.</div>
      <button type='submit' id='mc-embedded-subscribe'>Subscribe</button>
    </div>
    <div style={{ 'position': 'absolute', 'left': '-5000px' }}>
      <input type='text' name='b_ea280dd742ccfe0405dbfb8a8_d069566616' tabIndex='-1' />
    </div>
  </form>
)
